import { JaneGoldLearnMoreLink } from '@iheartjane/menu';
import {
  Box,
  Button,
  Flex,
  JaneGoldIcon,
  Typography,
  useMobileMediaQuery,
} from '@iheartjane/reefer';

import { useJaneGoldData } from '@jane/shared-ecomm/hooks';

import type { JaneGoldRewardsCalloutProps } from '../janeGoldCallout.types';

/**
 * Gold Rewards variant of the Jane Gold callout action component. This variant shows different states based on user authentication and bank linking status.
 */
export const JaneGoldRewardsCallout = ({
  isGuestUser,
  onLinkAccountClick,
  segmentedDeal,
}: JaneGoldRewardsCalloutProps) => {
  const { userHasLinkedBank } = useJaneGoldData();
  const isMobile = useMobileMediaQuery({});

  if (!isGuestUser && userHasLinkedBank) {
    return null;
  }

  return (
    <Box p={24} borderRadius="lg" border="grays-light">
      <Flex
        alignItems={isMobile ? 'center' : 'center'}
        justifyContent={isMobile ? 'center' : 'space-between'}
        flexDirection={isMobile ? 'column' : 'row'}
        gap={isMobile ? 16 : 0}
      >
        <Flex
          alignItems="center"
          flexDirection={isMobile ? 'column' : 'row'}
          gap={isMobile ? 12 : 8}
        >
          <JaneGoldIcon altText="jane-gold-icon" size="md" />
          <Flex
            alignItems="center"
            flexWrap="wrap"
            flexDirection={isMobile ? 'column' : 'row'}
          >
            <Typography
              mr={isMobile ? 0 : 4}
              variant="body-bold"
              textAlign={isMobile ? 'center' : undefined}
            >
              Jane Gold is a way to earn cash back rewards from your favorite
              cannabis brands.
            </Typography>
            <JaneGoldLearnMoreLink userHasLinkedBank={userHasLinkedBank} />
          </Flex>
        </Flex>
        <Button
          onClick={onLinkAccountClick}
          variant="secondary"
          label={
            isGuestUser
              ? segmentedDeal
                ? 'Sign in for eligibility'
                : 'Sign in'
              : 'Link bank account'
          }
        />
      </Flex>
    </Box>
  );
};
